import React, { useEffect, useRef } from 'react';

import Link from 'next/link';
import { useRouter } from 'next/navigation';

import { UserProfile } from '@repo/domain/user';
import { withEventScope } from '@repo/event-processor';
import { Tag } from '@repo/ui/components/Tag';
import { H3 } from '@repo/ui/components/Typography';
import noop from 'lodash/noop';

import { HeaderSearchComponentProps } from 'components/HeadMenu/HeaderSeach/types';
import Search from 'components/Search/Search';
import { buildPublicProfilePath } from 'global/urlUtils';

import { CategoryLabel, SearchWrapper, TrendingSearch } from './styles';

const HeaderSearchComponent: React.FC<HeaderSearchComponentProps> = ({
  trendingSearch,
  searchProps,
  isOpen,
  onClose,
}) => {
  const textInputRef = useRef<HTMLInputElement>(null);

  const router = useRouter();
  const handleSelectUser = (user: UserProfile): void => {
    onClose();
    void router.push(buildPublicProfilePath(user.slug));
  };

  const handleSearch = (query: string): void => {
    onClose();
    searchProps.onSearch(query);
  };

  useEffect(() => {
    if (isOpen) {
      textInputRef.current?.focus();
    }
  }, [isOpen]);

  return (
    <SearchWrapper>
      <H3>Find your perfect design</H3>
      <Search
        showLeftIcon
        dataTestId="header--search"
        inputRef={textInputRef}
        inputTheme={{
          width: '100%',
        }}
        query={searchProps.query}
        resetQuery={searchProps.resetQuery}
        tags={searchProps.tags}
        onCommit={handleSearch}
        onSelectOption={handleSearch}
        onSelectUser={handleSelectUser}
      />
      <TrendingSearch>
        <CategoryLabel>Trending Search:</CategoryLabel>
        {trendingSearch.map((trending) => {
          return (
            <Link
              key={trending.label}
              href={trending.path}
              rel="nofollow"
              onClick={onClose}
            >
              <Tag text={`#${trending.label}`} onClick={noop} />
            </Link>
          );
        })}
      </TrendingSearch>
    </SearchWrapper>
  );
};

export default withEventScope(HeaderSearchComponent, {
  module: 'headerSearch',
});
